<template>
  <div>
    <md-dialog :md-active="isVisible">
      <div class="encabezado text-center">
        <img src="../../isep/Tools/alert.gif" alt="" class="gif" />
      </div>
      <div class="p-3 text-center">
        <h5 class="m-4">{{ mensaje }}</h5>
        <md-button class="md-primary buton-alert col-6" @click="closeDialog">
          Continuar
        </md-button>
      </div>
    </md-dialog>
  </div>
</template>

<script>
export default {
  name: "DialogCustom",
  props: {
    showDialog: Boolean,
    mensaje: String,
  },
  data() {
    return {
      isVisible: this.showDialog,
    };
  },
  watch: {
    showDialog(newValue) {
      this.isVisible = newValue;
    },
  },
  methods: {
    closeDialog() {
      this.isVisible = false;
      this.$emit("update:showDialog", false);
    },
  },
};
</script>

<style lang="scss" scoped>
.md-dialog /deep/.md-dialog-container {
  width: 400px;
  border-radius: 30px;
}
.buton-alert {
  background-color: #ecdc7c;
  color: white !important;
}
.encabezado {
  background-color: #f7e374;
}
.gif {
  height: 4rem !important;
}
</style>
